import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionForceTakeoverPayload } from 'api/actions/revision-force-takeover/revision-force-takeover-payload';
import { RevisionForceTakeoverPathParameters } from 'api/actions/revision-force-takeover/revision-force-takeover-path-parameters';
import { RevisionForceTakeoverResponse } from 'api/actions/revision-force-takeover/revision-force-takeover-response';

type RevisionForceTakeoverQueryParameters = Record<string, any>;

/**
 * The path of the RevisionForceTakeover action.
 */
export const revisionForceTakeoverActionPath = new SweetPath<keyof RevisionForceTakeoverPathParameters>(
  '/api/revision/force-takeover/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionForceTakeover actions.
 */
export default function createRevisionForceTakeoverAction(axios: AxiosInstance) {
  return function revisionForceTakeoverAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionForceTakeoverPathParameters;
    query?: RevisionForceTakeoverQueryParameters;
    payload: RevisionForceTakeoverPayload;
  }) {
    const path = revisionForceTakeoverActionPath.insert(parameters);

    return axios.request<RevisionForceTakeoverResponse, RevisionForceTakeoverResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
